import { buildAuthHeaders } from '../../utils/buildAuthHeaders';
import { handleResponse } from 'api/helpers/helpers';
import * as constants from './../../constants';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const getAllAvailableLanguages = async () => {
  const myHeaders = buildAuthHeaders();
  try {
    const res = await fetch(`${process.env.REACT_APP_TOUR_API}/v2/languages`, {
      headers: myHeaders,
      credentials: 'include',
    });

    const result = await handleResponse(res);
    return result;
  } catch (error) {
    throw error;
  }
};

export const addLanguageToTour = async (lang, tourId) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');

  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/translations/${lang}`,
    {
      headers: myHeaders,
      method: 'POST',
      credentials: 'include',
    }
  );

  const result = await handleResponse(res);
  return result;
};

export const updateLanguageOnTour = async (updates, tourId) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');

  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/languages`,
    {
      headers: myHeaders,
      method: 'PUT',
      body: JSON.stringify(updates),
      credentials: 'include',
    }
  );
  return await await handleResponse(res);
};

export const updateTranslationsOnTour = async (updates, tourId, lang) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');

  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/translations/${lang}`,
    {
      headers: myHeaders,
      method: 'PUT',
      body: JSON.stringify(updates),
      credentials: 'include',
    }
  );
  return await await handleResponse(res);
};

export const getTourTranslationsByLanguage = async (lang, tourId) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');

  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/translations/${lang}`,
    {
      headers: myHeaders,
      credentials: 'include',
    }
  );
  const result = await handleResponse(res);
  return result;
};

export const _updateTourTranslationByType = async (
  updates,
  tourId,
  type,
  lang,
  id
) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');

  let route = `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/translations/${lang}`;
  if (type !== 'tour') route = `${route}/${type}/${id}`;
  else route = `${route}?partial=true`;

  const res = await fetch(route, {
    headers: myHeaders,
    method: 'PUT',
    body: JSON.stringify(updates),
    credentials: 'include',
  });
  return await await handleResponse(res);
};

export const _getTourTranslationsByType = async (lang, tourId, type, id) => {
  const myHeaders = buildAuthHeaders();
  const aid = localStorage.getItem('aid');
  let route = `${process.env.REACT_APP_TOUR_API}/v2/${aid}/tours/${tourId}/translations/${lang}`;
  if (type !== 'tour') route = `${route}/${type}/${id}`;
  else route = `${route}?partial=true`;

  const res = await fetch(route, {
    headers: myHeaders,
    credentials: 'include',
  });
  return await handleResponse(res);
};

export const fetchPublicTourLanguagesApi = async id => {
  let myHeaders = buildAuthHeaders();
  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/published/${id}/available`,
    {
      headers: myHeaders,
      credentials: 'include',
    }
  );
  return handleResponse(res);
};

const updateDownloadJobStatus = async ({ jobId, accId, tourId }) => {
  const myHeaders = buildAuthHeaders();
  const res = await fetch(
    `${process.env.REACT_APP_TOUR_API}/v2/${accId}/tours/${tourId}/translations/all/csv/${jobId}`,
    {
      headers: myHeaders,
    }
  );

  return await handleResponse(res);
};

const downloadCSVJobCheck = async ({ jobId, accId, tourId }) => {
  let timeOut = constants.DOWNLOADTIMEOUT;

  return new Promise((resolve, reject) => {
    const downloadTimer = setInterval(async () => {
      if (timeOut <= 0) {
        clearInterval(downloadTimer);
        reject({
          status: 408,
          message: 'Request Timeout, process took too long',
        });
      }

      const data = await updateDownloadJobStatus({ jobId, accId, tourId });
      if (data.status === 'error' || data.status === 'complete') {
        clearInterval(downloadTimer);
        if (data.status === 'complete') resolve(data.url);
        else reject(data);
        return;
      }
      --timeOut;
    }, 3000);
  });
};

const postDownloadCSV = async (accId, tourId) => {
  const myHeaders = buildAuthHeaders();
  try {
    const res = await fetch(
      `${process.env.REACT_APP_TOUR_API}/v2/${accId}/tours/${tourId}/translations/all/csv`,
      {
        headers: myHeaders,
        method: 'POST',
      }
    );

    return await handleResponse(res);
  } catch (error) {
    throw error;
  }
};

export const downloadTranslationCSV = url => {
  return fetch(url, {
    method: 'GET',
  })
    .then(response => response.blob())
    .then(blob =>
      saveAs(blob, `Translations_${moment().format('MM-DD-YYYY')}.csv`)
    )
    .catch(e => {
      console.error(e);
      window.open(url);
    });
};

export const getDownloadCSVUrl = async (accId, tourId) => {
  try {
    const jobId = await postDownloadCSV(accId, tourId);

    return await downloadCSVJobCheck({ jobId, accId, tourId });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
